import gql from 'graphql-tag';

import accountCardDetails from '../fragments/accountCardDetails';

export const accountCardCreate = gql`
  mutation accountCardCreate($input: AccountCardCreateInput!) {
    accountCardCreate(input: $input) {
      account_card {
        ...accountCardDetails
      }
    }
  }
  ${accountCardDetails}
`;

export const accountCardUpdate = gql`
  mutation accountCardUpdate($input: AccountCardUpdateInput!) {
    accountCardUpdate(input: $input) {
      account_card {
        ...accountCardDetails
      }
    }
  }
  ${accountCardDetails}
`;

export const accountCardsDelete = gql`
  mutation accountCardsDelete($input: AccountCardsDeleteInput!) {
    accountCardsDelete(input: $input) {
      success
    }
  }
`;

export const accountCardClone = gql`
  mutation accountCardClone($input: AccountCardCloneInput!) {
    accountCardClone(input: $input) {
      account_card {
        ...accountCardDetails
      }
    }
  }
  ${accountCardDetails}
`;
